import React from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { UiButton } from '@shared/ui';

import cls from './PeopleCard.module.css';
import { usePeopleCard } from './usePeopleCard';
import { Icon } from '../../../../../../components/newUI/Icon/Icon';
import { ProjectUser, Roles } from '../../../../../AddProject/types/types';

interface PeopleCardProps {
    classes?: string;
    user: ProjectUser;
    onDelete?: () => void;
    role?: string;
}

export const PeopleCard = ({ classes, user, role }: PeopleCardProps) => {
    const { onDeleteEmployer, managers, showDeleteButton } = usePeopleCard(user);

    const { t } = useTranslation();

    return (
        <div className={classNames(cls.PeopleCard, [classes])}>
            {showDeleteButton &&
                (role === Roles.MANAGER && managers.length > 1 ? (
                    <UiButton
                        className={cls.DeleteCard}
                        onClick={onDeleteEmployer}
                        variant="icon"
                        startIcon={<Icon iconName="deleteCard" />}
                    />
                ) : (
                    role !== Roles.MANAGER &&
                    showDeleteButton && (
                        <UiButton
                            className={cls.DeleteCard}
                            onClick={onDeleteEmployer}
                            variant="icon"
                            startIcon={<Icon iconName="deleteCard" />}
                        />
                    )
                ))}
            <div className={cls.Content}>
                <div className={cls.PeopleAvatar}>
                    {user.avatar ? (
                        <img src={user.avatar} alt={t('PeopleCard.return.img')} />
                    ) : (
                        <Icon iconName="profileBigSize" />
                    )}
                </div>
                <div className={cls.PeopleInfo}>
                    <span className={cls.PeopleName}>{user.name}</span>
                    <span className={cls.PeopleEmail}>{user.email}</span>
                </div>
            </div>
        </div>
    );
};
